import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { api } from '@/lib/api';
import { tr, uiLocale } from '@/i18n/copy';

const exitDate = value => value ? new Date(value).toLocaleString(uiLocale()) : '—';
export default function OffboardingBanner() {
  const { user } = useAuth(); const [data,setData]=useState(null);
  useEffect(()=>{if(user?.role!=='studio_owner')return;let alive=true;api.get('/offboarding/status').then(r=>{if(alive)setData(r);}).catch(()=>{});return()=>{alive=false;};},[user?.id,user?.studio_id,user?.role]);
  if(!data?.mode)return null;
  return <div className="mb-4 rounded-xl border p-4 text-sm" role="status"><b>{tr(data.status_label)}</b>{data.export_until&&<p>{tr('Termine recupero:')} {exitDate(data.export_until)}</p>}<Link className="underline" to="/data-exit">{tr('Cessazione e dati: controlla scadenze e avvisi')}</Link></div>;
}
